import {
  Dialog,
  Button,
  Divider,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@mui/material';

import useLocales from 'src/hooks/useLocales';

import { WorkflowSubjectType } from 'src/@types/workflow/types';

import WorkflowBindingPanel from './WorkflowBindingPanel';

type WorkflowBindingDialogProps = {
  subjectType: WorkflowSubjectType;
  subjectId: number;
  subjectName?: string;
  isOpen: boolean;
  onClose: () => void;
};

export default function WorkflowBindingDialog({
  subjectType,
  subjectId,
  subjectName,
  isOpen,
  onClose,
}: WorkflowBindingDialogProps) {
  const { t } = useLocales();

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ pb: 1 }}>
        {t('workflows.binding.title')}

        {subjectName && (
          <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }} noWrap>
            {subjectName}
          </Typography>
        )}
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 2.5, pb: 1 }}>
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
          {t(`workflows.binding.subheader.${subjectType}`)}
        </Typography>

        {isOpen && (
          <WorkflowBindingPanel embedded subjectType={subjectType} subjectId={subjectId} />
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button color="inherit" onClick={onClose}>
          {t('shared.buttons.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
